import { useRequiredContext } from "@redotech/react-util/context";
import ClockRewindIcon from "@redotech/redo-icons/clock-rewind_filled.svg";
import ClockIcon from "@redotech/redo-icons/clock.svg";
import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-01.svg";
import ShoppingBagFilledIcon from "@redotech/redo-icons/shopping-bag-01_filled.svg";
import ShoppingCartIcon from "@redotech/redo-icons/shopping-cart-01.svg";
import ShoppingCartFilledIcon from "@redotech/redo-icons/shopping-cart-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import {
  RedoSecondaryNavItem,
  useNavTreeNode,
} from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";

const ALLOWED_TEAM_IDS = ["67bcec3da5f96e35fa38ea31"];

export function useRedoSuppliesNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useContext(TeamContext);

  const isDev = process.env.NODE_ENV === "development";
  const isAllowedTeam = !!team?._id && ALLOWED_TEAM_IDS.includes(team._id);

  if (!isDev && !isAllowedTeam) {
    return null;
  }

  const primaryTab: LinkPrimaryTab = {
    id: "redo-supplies",
    hasNotification: false,
    UnfilledIcon: ShoppingCartIcon,
    FilledIcon: ShoppingCartFilledIcon,
    type: "link",
    href: routes.redoSuppliesShopHref,
    pathRoot: routes.redoSuppliesBaseUrl,
    friendlyName: "Redo Supplies",
  };

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "redo-supplies",
    name: "Redo Supplies",
    NavContent: SecondaryRedoSuppliesNavigation,
  };

  return { primaryTab, secondaryNavigationData };
}

const SecondaryRedoSuppliesNavigation = memo(
  function SecondaryRedoSuppliesNavigation() {
    const routes = useRequiredContext(MerchantRoutesContext);

    const { id: nodeId, TreeContext } = useNavTreeNode({
      friendlyName: "Redo Supplies",
    });

    return (
      <TreeContext.Provider value={nodeId}>
        <RedoSecondaryNavItem
          action={{ type: "link", href: routes.redoSuppliesShopHref }}
          FilledIcon={ShoppingBagFilledIcon}
          friendlyName="Shop"
          id="redo-supplies-shop"
          UnfilledIcon={ShoppingBagIcon}
        />
        <RedoSecondaryNavItem
          action={{ type: "link", href: routes.redoSuppliesOrderHistoryHref }}
          FilledIcon={ClockRewindIcon}
          friendlyName="Order history"
          id="redo-supplies-order-history"
          UnfilledIcon={ClockIcon}
        />
      </TreeContext.Provider>
    );
  },
);
